import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { classNames } from "@via/utils/helpers.tsx";
import { type JSX } from "react";

export const ScriptFilesList = ({
  files,
  selected,
  setSelected,
}): JSX.Element => {
  return (
    <ul role="list" className="flex min-w-56 flex-col space-y-1.5 pt-3">
      {files.map(file => (
        <li
          key={file.filename}
          onClick={() => setSelected(file.filename)}
          className={classNames(
            file.filename === selected
              ? "font-medium text-indigo-600"
              : "text-black hover:text-indigo-600",
            "text-md group flex cursor-pointer flex-row items-center gap-x-3 rounded-md text-[16px] leading-6"
          )}>
          <DocumentTextIcon className="h-4 w-4 text-gray-400" /> {file.label}
        </li>
      ))}
    </ul>
  );
};
